/* Home AmerigoStore: slideshow, schede inverno, ricerca calze da neve per misura. */
(function () {
  function initHero(el) {
    if (el.dataset.amReady) return; el.dataset.amReady = '1';
    var slides = el.querySelectorAll('.am-slide'), dots = el.querySelectorAll('.am-dots button'), i = 0, t;
    if (slides.length < 2) return;
    function go(n) {
      slides[i].classList.remove('is-on'); dots[i].classList.remove('is-on');
      i = n;
      slides[i].classList.add('is-on'); dots[i].classList.add('is-on');
      el.classList.toggle('is-lite', slides[i].classList.contains('am-slide--split'));
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); clearInterval(t); }); });
    var sec = parseInt(el.dataset.seconds || '6', 10);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && !window.Shopify?.designMode) {
      t = setInterval(function () { go((i + 1) % slides.length); }, sec * 1000);
    }
  }

  function initTabs(el) {
    if (el.dataset.amReady) return; el.dataset.amReady = '1';
    var tabs = el.querySelectorAll('.am-tabs button');
    tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        tabs.forEach(function (x) {
          x.setAttribute('aria-selected', x === b ? 'true' : 'false');
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = x !== b;
        });
      });
    });
  }

  function euro(n) { return '€' + n.toFixed(2).replace('.', ','); }

  function initCalze(el) {
    if (el.dataset.amReady) return; el.dataset.amReady = '1';
    var form = el.querySelector('form'), res = el.querySelector('.am-res');
    var sw = el.querySelector('[name="w"]'), ss = el.querySelector('[name="s"]'), sr = el.querySelector('[name="r"]');
    var db = null;
    function fill(sel, values, ph) {
      sel.innerHTML = '<option value="">' + ph + '</option>' + values.map(function (v) { return '<option>' + v + '</option>'; }).join('');
      sel.disabled = values.length === 0;
    }
    function uniq(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }).sort(function (x, y) { return x - y; }); }
    function sizes() { return Object.keys(db).map(function (k) { var m = k.match(/(\d+)\/(\d+)-(\d+)/); return { k: k, w: m[1], s: m[2], r: m[3] }; }); }
    fetch(el.dataset.src).then(function (r) { return r.json(); }).then(function (j) {
      db = j;
      fill(sw, uniq(sizes().map(function (x) { return x.w; })), 'Larghezza');
      fill(ss, [], 'Serie'); fill(sr, [], 'Cerchio');
    }).catch(function () { res.innerHTML = '<p>Ricerca non disponibile: usa "Vedi tutte le calze".</p>'; });
    sw.addEventListener('change', function () {
      fill(ss, uniq(sizes().filter(function (x) { return x.w === sw.value; }).map(function (x) { return x.s; })), 'Serie');
      fill(sr, [], 'Cerchio'); res.innerHTML = '';
    });
    ss.addEventListener('change', function () {
      fill(sr, uniq(sizes().filter(function (x) { return x.w === sw.value && x.s === ss.value; }).map(function (x) { return x.r; })), 'Cerchio');
      res.innerHTML = '';
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!db) return;
      var k = sw.value + '/' + ss.value + '-' + sr.value, list = db[k];
      if (!list || !list.length) { res.innerHTML = '<p>Scegli larghezza, serie e cerchio come scritti sul fianco del pneumatico.</p>'; return; }
      res.innerHTML = '<p>' + list.length + (list.length === 1 ? ' calza compatibile' : ' calze compatibili') + ' con ' + k.replace('-', ' R') + ':</p>' +
        list.map(function (p) { return '<a href="/products/' + p[0] + '">' + p[1] + '<span>' + euro(p[2]) + '</span></a>'; }).join('');
    });
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-am-hero]').forEach(initHero);
    (root || document).querySelectorAll('[data-am-tabs]').forEach(initTabs);
    (root || document).querySelectorAll('[data-am-calze]').forEach(initCalze);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
